<template>
    <div class="wrap-library">
        <div class="headerimg">
          <img :src="headImg" alt="">
          <div class="realtime">
              <marqueeLeft :sendVal='newItems' :id="proId"></marqueeLeft >
          </div>
          <div class="relate-black">

          </div>
        </div>
      <van-tabs v-model="active"  title-active-color="#AB74B1" sticky class="channel-tab">
        <van-tab title="项目介绍" >
          <div class="library-header" style="padding-bottom: 10px">
<!--            <div class="title-detail">-->
<!--              <h3>{{title}}</h3>-->
<!--            </div>-->
            <div class="title-librarycontent">
              <div v-html="contentInfo">
              </div>
            </div>
            <div class="project-banner">
              <swiper :options="swiperOptionbanner" ref="mySwiper1">
                <swiper-slide>
                  <img src="../assets/projectbaner.png" alt="">
                </swiper-slide>
                <swiper-slide>
                  <img src="../assets/projectbanner2.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                  <img src="../assets/projectbanner3.jpg" alt="">
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
            </div>
          </div>
        </van-tab>
        <van-tab title="筹款记录">
          <div class="raise">
            <div class="raise-record">
              <ul class="raise-record-header">
                <li>
                  <span class="reaise-record-title">已捐助：</span>
                  <span  class="reaise-record-num">{{ sumAmount | sumFormat}}</span>
                  <span class="unit">本</span>
                </li>
                <li>
                    <!--    后续根据 返回值的正负 判断   多捐或者尚缺       -->
                  <span  class="reaise-record-title">多捐：</span>
                  <span class="reaise-record-num">{{lackAmount | sumFormat}}</span>
                  <span class="unit">本</span>
                </li>
                <li>
                  <span  class="reaise-record-title">筹集目标：</span>
                  <span class="reaise-record-num" style="color: #000000">{{activFund | sumFormat}}</span>
                  <span class="unit">本</span>
                </li>
              </ul>
              <div class="raise-progress">
                <van-progress
                    :percentage="process"
                    stroke-width="10"
                    pivot-text=""
                    color="linear-gradient(270deg, #AB73A9 -8.84%, #C199C6 25.43%, #D3BBD6 59.71%)"
                    track-color="#DFDCDF"
                />
              </div>
              <!--            <seamscroll></seamscroll>-->
            </div>
            <div class="raise-list">
              <span style="padding-top: 15px">共计收到{{totalsize}}份捐助，感谢有你</span>
              <ul><van-list
                  v-model="loading"
                  :finished="finished"
                  finished-text="没有更多了"
                  @load="onLoad"
              >
                <li  v-for="(item,index) in raiseList" :key="index">
                  <span>{{item.nickName | nameencry}}</span>
                  <span>捐助{{item.ordAmount | sumFormat}}本</span>
                  <span>{{item.successTime | relativeTime}}</span>
                </li>
                <!--                <van-cell v-for="item in list" :key="item" :title="item" />-->
              </van-list></ul>
            </div>
          </div>

         </van-tab>
        <van-tab title="爱心图书榜" >
          <div class="recommendPage">

            <swiper :options="swiperOption" ref="mySwiper">
<!--              <swiper-slide>-->
<!--                <div class="recommendPage-title">-->
<!--                  <span>按团体排名</span>-->
<!--                </div>-->
<!--                <div class="lovecontent">-->
<!--                  <ul>-->
<!--                    <li v-for="(item,index) in organData" :key="index">-->
<!--                      <div class="lovecontent-left">-->
<!--                        <span >第{{item.rowNum}}名</span>-->
<!--                      </div>-->

<!--                      <div class="lovecontent-right">-->
<!--                        <span>{{item.orgName }}累计捐赠了{{item.sumAmount | sumFormat}}本</span>-->
<!--                      </div>-->

<!--                    </li>-->
<!--                  </ul>-->
<!--                </div>-->

<!--              </swiper-slide>-->
              <swiper-slide>
                <div class="lovecontent">
<!--                  <div class="recommendPage-title">-->
<!--                    <span>按个人排名</span>-->
<!--                  </div>-->
                  <ul >

                    <li v-for="(item,index) in personData" :key="index">
<!--                      <div class="lovecontent-left">-->
<!--                        <span >第{{item.rowNum}}名</span>-->
<!--                      </div>-->

                      <div class="lovecontent-right">
                        <span>{{item.nickName }}捐款了{{item.sumAmount | sumFormat}}本</span>
                      </div>

                    </li>
                  </ul>
                </div>

              </swiper-slide>
<!--              <div class="swiper-button-prev" slot="button-prev"></div>-->
<!--              <div class="swiper-button-next" slot="button-next"></div>-->
            </swiper>
          </div>
        </van-tab>
      </van-tabs>
      <van-goods-action class="googs-actions-wrap">
        <van-goods-action-icon  class="iconfont icon-Vector1" text="首页" @click="onClickIcon" color="#AB74B1" >
        </van-goods-action-icon>
        <van-goods-action-button
            type="danger"
            text="募集已结束"
            v-if="this.activStatus == 2"
            :disabled=true
        />
        <van-goods-action-button
            v-else
            type="danger"
            text="参与捐助"
            @click="donateOnclick"
        />
      </van-goods-action>
      <!--   金额提示 -->
<!--      <van-action-sheet-->
<!--          v-model="donationShow"-->
<!--          close-on-click-action-->
<!--      >-->
<!--        <div class="donation">-->
<!--          <span class="donation-num">捐款金额(元)</span>-->
<!--        <ul >-->
<!--          <li v-for="(item,index) in moneyList" :key="index" @click="moneyClick(item,index)"-->
<!--              :class="currentIndex == index ? 'is-active':''">-->
<!--            {{item.value}}-->
<!--          </li>-->
<!--          <li class="marginleft">-->
<!--            <van-field v-model="digit" type="digit"-->
<!--           style="background-color: #F4F2F4 !important;border-radius: 62px !important;"-->
<!--           @focus="customFocus"-->
<!--           placeholder="自定义金额"/>-->
<!--          </li>-->
<!--        </ul>-->

<!--        <div class="submit" @click="onHandler">-->
<!--           <span>确认捐款</span>-->
<!--        </div>-->
<!--        </div>-->

<!--      </van-action-sheet>-->
      <!--  总金额提示  -->

      <van-action-sheet
          v-model="TotaldonationShow"
          close-on-click-action
      >
        <div class="totaldonation">
          <div class="raise-record">
            <ul class="raise-record-header">
              <li>
                <span class="reaise-record-title">已捐助：</span>
                <span  class="reaise-record-num">{{ sumAmount | sumFormat}}</span>
                <span class="unit">本</span>
              </li>
              <li>
                <span  class="reaise-record-title">多捐：</span>
                <span class="reaise-record-num">{{lackAmount | sumFormat}}</span>
                <span class="unit">本</span>
              </li>
              <li>
                <span  class="reaise-record-title">筹集目标：</span>
                <span class="reaise-record-num" style="color: #000000">{{activFund | sumFormat}}</span>
                <span class="unit">本</span>
              </li>
            </ul>
            <div class="raise-progress">
              <van-progress
                  :percentage="process"
                  stroke-width="10"
                  pivot-text=""
                  color="linear-gradient(270deg, #AB73A9 -8.84%, #C199C6 25.43%, #D3BBD6 59.71%)"
                  track-color="#DFDCDF"
              />
            </div>
            <div class="raise-line">
            </div>
            <div class="raise-record-bottom">
              <div class="raise-record-bottom-text">
                <span>捐助数量</span>
                <span>（每本书20元）</span>
              </div>
              <ul class="raise-num">
                <li v-for="(item,index) in moneyList" :key="index" @click="moneyClick(item,index)"
                    :class="currentIndex == index ? 'is-active':''">
                  {{item.value}}本
                </li>
              </ul>
              <div class="raise-custom">
                <van-field v-model="digit"
                           type="digit"
                           style="background-color: #fff !important;border-radius: 62px !important;border: 1px solid #BDB4BE;"
                           input-align="center"
                           @focus="customFocus"
                           @blur="customBlur"
                           placeholder="自定义"/>
              </div>
              <div class="raise-confirm">
                <div class="sum">
                  <span class="sum-text">总价：</span>
                  <span class="sum-total">{{totalNum}}</span>
                  <span class="sum-unit">元</span>
                </div>
                <div class="sum-confrim" @click="onHandler">
                  <span>确认捐款</span>
                </div>
              </div>
            </div>
          </div>

        </div>

      </van-action-sheet>


      <van-popup v-model="loginshow" class="loginPop">
          <van-form  ref="form" @submit="loginSubmit">
            <van-field
                v-model="totalNum"
                label="捐赠金额(元)"
                :disabled=true
            />
            <van-field
                v-model="userObject.username"
                name="username"
                placeholder="姓名"
                maxlength="6"
                :rules="[{ required: true, message: '请填写姓名' }]"
            >
              <i slot="left-icon" class="iconfont icon-yonghu"></i>
            </van-field>
            <van-field
                v-model="userObject.tel"
                name="tel"
                placeholder="请输入手机号"
                :rules="telRules"
                type="number"
                maxlength="11"
            >
              <i slot="left-icon" class="iconfont icon-shouji"></i>
            </van-field>
            <van-field
                readonly
                clickable
                name="picker"
                :value="value"
                placeholder="点击选择项目"
                @click="showPicker = true"
            >
              <i slot="left-icon" class="iconfont icon-shouji"></i>
            </van-field>
            <van-field
                v-model="userObject.code"
                name="code"
                placeholder="请输入验证码"
                :rules="codeRules"
                type="number"
                maxlength="4"
                class="codeRules"
            >
              <i slot="left-icon" class="iconfont icon-yanzhengma" ></i>
              <template #button>
                <van-button  round  size="small" type="primary" v-show="pstatus === 0"  class="" @click="smsHandler"  native-type="button" >发送验证码</van-button>
                <van-button round   size="small" type="primary" v-show="pstatus === 1" @click="smsHandler" native-type="button"  >重新获取</van-button>
                <van-button round   size="small" type="primary" v-show="pstatus === 2" native-type="button">{{times}}s</van-button>
              </template>
            </van-field>
            <div style="margin: 16px;">
              <van-button round block type="info" native-type="submit">提交</van-button>
            </div>
          </van-form>
      </van-popup>
    </div>
</template>

<script>
import seamscroll from "../component/seamscroll";
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import marqueeLeft from '../component/textScroll'
import {
  getdataInfo,
  getdataInfoUpdatePay,
  oneList,
  PayDonation,
  proOrders,
  proInfoReport,
  lastProOrders,
  proInfo,
  sendMessage,
  login,
  getLoveOrgan,
  getLovePerson,getLoveorglist
} from '../api/index'
import { mapState } from 'vuex'
import {Dialog, Toast} from "vant";
export default {
  name: "index",
  data(){
    return {
      activStatus:null,
      idList:[],
      organData:[],
      personData:[],
      donateNum:0,
      loginshow:false,
      headImg:'',
      title:'',
      contentInfo:'',
      proId:null,
      donationIndex:1,
      digit:null,
      checkbox: false,
      donationShow:false,
      childrenList:[],
      scrollTop:0,
      active: 0,
      customNum:5,
      TotaldonationShow:false,
      currentIndex:0,
      moneyList:[
        {
          id:0,
          value:5
        },
        {
          id:1,
          value:20
        },
        {
          id:2,
          value:100
        }
      ],
      activObj:{},
      raiseList:[],
      page:1,
      limit:3,
      loading: false,
      finished: false,
      totalsize:0,
      activFund:0,
      lackAmount:0,
      sumAmount:0,
      process:0,
      vanList:[],
      newItems:[
      ],
      orderId:'',
      flag:true,
      timer:null,
      userObject:{
        username:'',
        tel:'',
        code:'' ,//验证码
      },
      pstatus:0,
      times:60,
      backCode:'',
      telRules: [{
        required: true,
        message: '手机号不能为空',
        trigger: 'onBlur'
      }, {
        // 自定义校验规则
        validator: value => {
          return /^1[3456789]\d{9}$/   .test(value)

        },
        message: '手机格式错误',
        trigger: 'onBlur'
      }],
      codeRules: [{
        required: true,
        message: '请填写验证码',
        trigger: 'onBlur'
      }],
      swiperOption: {
        slidesPerView: 1,
        loop: false,
        autoplay:false,
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      swiperOptionbanner: {
        slidesPerView: 1,
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true //允许分页点击跳转
        }
        // 设置点击箭头
      },
      value:'',
      columns: ['杭州', '宁波', '温州', '嘉兴', '湖州'],
      showPicker: false,
    }
  },
  components:{
    marqueeLeft,
    Swiper,
    SwiperSlide
  },
  created(){
    this.proId = this.$route.query.proId
    this.proInfoReport()
    this.lastProOrders()
    this.proInfo()
    this.getOneList()
    this.getLoveOrganData()
    this.getLovePersonData()
  },
  mounted() {
    //this.getdata()
   const libid = this.$route.query.libid ? this.$route.query.libid: 1
   const certid  = this.$route.query.certid ? this.$route.query.certid: 1

    console.log(this.$route.query.certid)
    if (libid == '3') {
      this.active = 2
    }
    if (certid == '2'){
      this.active = 1
    }
  },
  computed:{
    ...mapState(['user']),
    totalNum () {
      let totalNum = 0
      if(this.digit != 0){
        totalNum = 20* this.digit
      }else {
        totalNum = 20*this.customNum
      }
      return totalNum
    }
  },
  // watch:{
  //   'customNum':function(newval,oldval){
  //     console.log(newval,oldval)
  //     this.totalNum = newval*20
  //   }
  // },
  // filters:{
  //   filter_num(value){
  //    let num = Math.trunc(3750*(value/100))
  //     return num
  //   }
  // },
  methods:{
    async getList() {
      const res = await getLoveorglist()
      if (res.code == 200){
        this.idList = res.data
      }
    },
    async getLoveOrganData(){
      const res = await getLoveOrgan({'proId': 3})
      if (res.code === 200){
        this.organData= res.data
      }
    },
    async getLovePersonData(){
      const res = await getLovePerson({'proId': 3})
      if (res.code === 200){
        this.personData= res.data
      }
    },
    smsHandler(){
      // 局部表单验证
      this.$refs.form.validate('tel').then(() => {
        this.sendMessageInfo(this.userObject.tel)
      })

    },
    async sendMessageInfo(tel){
      try {
        await this.$refs.form.validate('tel')
        const data = await sendMessage(tel)
        if(data.code == 200){
          this.backCode = data.data
          Toast.success('短信发送成功，请查看');
          this.countDown()
        }
      }catch (e) {
        return console.log('手机格式输入错误',e)
      }

    },
    //倒计时修改
    countDown:function(){
      var that = this;
      that.pstatus = 2;
      that.times = 60;
      var st = setInterval(function(){
        that.times = that.times - 1;
        if(that.times === 0) {
          clearInterval(st);
          that.pstatus = 1;
        }
      },1000);
    },
    moneyClick(item,index){
      this.digit = null
      this.currentIndex = index
      // this.donationShow = false
      this.customNum = item.value
    },
    oneClick(index){
      this.donationIndex = index
      this.TotaldonationShow = false
      this.active = 1
    },
    together(index){
      this.donationIndex = index
      this.TotaldonationShow =false
      setTimeout(()=>{
        this.donationShow = true
      },500)
    },
    async getOneList(){
      const onelist = await oneList({proId:this.proId})
      this.childrenList = onelist.data
      console.log(this.childrenList)
      Toast.loading({
        duration: 100,
        message: '加载中...',
        forbidClick: true,
      });
      // console.log(onelist)
    },
    onClickIcon(){
      this.$router.push('/')
    },
    donateOnclick(){
     this.TotaldonationShow = true
    },
    async payOnclick(){
      let data = await getdataInfoUpdatePay()
      window.location.href=data.data
       //window.open(data.data)
    },

    handlerOnclick(item){
      this.$router.push({
        path: '/detail',
        query:{id:item.psId, proId:item.proId,stuId:item.stuId,stuname:item.stuName }
      })
    },

    onHandler(){
      if(!this.customNum && ! this.digit){
        Toast('请填写或者选择金额')
        return
      }
      if(this.user && this.user.orgName){
        /*调整新的页面进行处理*/
        // this.loginshow = true
        this.throlttle()
      }else{
        this.$router.push({name:'paylibrary',params:{"proId":this.$route.query.proId,'ordAmount':20*this.customNum}})

      }
    },
    isInteger(obj){
      return obj%50 === 0
    },
    customFocus(){
      this.currentIndex = 10
      this.customNum = 0
    },
    customBlur(){
      // if(Number(this.digit)<5){
      //   console.log(1234567)
      //   Toast.fail('数量不能小于5');
      //   return
      // }
      this.customNum = this.digit
    },
    confirmNum(){
        Dialog.confirm({
        title: '',
        message: `你确认捐助${this.customNum}元吗？`,
      }).then(() => {
        console.log('确认金额')
        this.onSubmit()

      }).catch(() => {
        // on cancel
        console.log('取消认捐')
      });


    },
    agreement(){
      this.$router.push('/agreement')
    },
    throlttle(){
      if(this.flag) {
        this.flag = false
        this.onSubmit()
        this.timer = setTimeout(() => {
          this.flag = true
        }, 5000)
      }
    },
    async onSubmit(){
      const data = await PayDonation({"proId":this.$route.query.proId,'ordAmount':20*this.customNum,'puId':this.user.puId,'returnUrl':'https://charity.sohochina.com/#/pay'})
      Toast.loading({
        duration: 100,
        message: '提交中...',
        forbidClick: true,
      });
      if(data.code == 500){
        // Toast.setDefaultOptions({ duration: 3000 });
        Toast(data.msg);
      }else {
        this.orderId = data.data.ordId
        window.localStorage.setItem('ordId',this.orderId)
        console.log(this.orderId)
        // this.$store.commit('setId',data.data.ordId)
       window.location.href= data.data.payUrl
      }

    },
    async proInfo(){
      const data = await proInfo({"proId":this.$route.query.proId})
      if(data.code == 200) {
        this.headImg = JSON.parse(data.data.phoLink).proLink
        this.title = data.data.activTitle
        this.contentInfo = data.data.activInfo
        let activObj = data.data.activObj
        this.activStatus = data.data.activStatus
       this.activObj = JSON.parse(activObj)
      }

    },
    async onLoad(){
      const data = await proOrders({"proId":this.$route.query.proId,'page':this.page,'limit':this.limit })
      if(data.code == 200){
        let list = data.data.list
        this.totalsize = data.data.totalCount
        this.raiseList.push(...list)
        this.page = this.page+1
      }
      this.loading = false
     console.log(this.totalsize)
     if(this.raiseList.length == data.data.totalCount){
       this.finished = true
     }
    },
    async proInfoReport(){
      Toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      const data = await proInfoReport({"proId":this.$route.query.proId})
      if(data.code == 200){
        this.activFund= data.data.activFund
        this.lackAmount = Math.abs(data.data.lackAmount)

        this.sumAmount = data.data.sumAmount
        const process = (this.sumAmount/this.activFund).toFixed(2)
        if(data.data.lackAmount<0){
          this.process = 1*100
          return
        }
        this.process = process*100
      }
    },
    async lastProOrders(){
      const data = await lastProOrders({"proId":this.$route.query.proId})
      if(data.code == 200){
        this.newItems = data.data
      }
    },
    async loginSubmit() {
      const user = this.userObject
      this.$refs.form.validate().then(() => {
        if(this.backCode != this.userObject.code){
          Toast('验证码输入不正确');
          return
        }
      }).catch(() => {

      })
      Toast.loading({
        message: '提交中...',
        forbidClick: true,
        duration:0
      });
      try {
        const res = await login(user)
        if(res.code == 200){
          this.$store.commit('setUser',res.data)
          this.loginshow = false
          this.donationShow = false
          // this.confirmNum()
          this.throlttle()

        }else {
          Toast('提交失败，请重试')
        }

      }catch (err){
        if(err.response.status == 400){
          console.log('手机号或者验证码错误')
        }else{
          console.log('登录失败，请重试',err)
        }

      }
    },

  },

  beforeDestroy() {
    clearTimeout(this.timer)
    this.timer =  null
  }

}
</script>

<style lang="scss">
.loginPop{
  width: 600px;
  height: 610px;
  .van-form{
    background: #FFFFFF;
    padding:30px 0;
    box-sizing: border-box;
  }
}
.library-header{
  // font-family: 'PingFang HK';
  font-style: normal;
  font-weight: 300;
  font-size: 32px;
  line-height: 28px;
  color: #000000;
}
.swiper-pagination-bullet-active {
  background: white;
}
.swiper-button-prev{
  left: 260px;
  background: url("../assets/left.png") no-repeat 0 2px;
  width: 60px;
  height: 60px;

}
.swiper-button-next{
  right: 220px;
  background: url("../assets/right.png") no-repeat 0 2px;
  width: 60px;
  height: 60px;
}
.swiper-button-prev, .swiper-button-next{
  top: 0;
}
.swiper-button-prev:after, .swiper-button-next:after{

}
.van-checkbox__icon .van-icon{
  border-radius: 50% !important;
  font-size: 24px !important;
}
.googs-actions-wrap{
  .van-button__text{
    font-size: 34px;
  }
}

.van-list__finished-text{
  opacity: 0;
}
//.van-cell{
//  background-color: #F4F2F4 !important;
//  border-radius: 62px !important;
//}
.van-goods-action{
  padding: 0 40px;
}
.channel-tab {
  .van-tabs__line{
    background-color: #AB74B1 !important;
    width: 100px;
  }

  .van-tabs__wrap {
    position: relative;
    width: 100%;
    //border-bottom: 1px solid red;
    margin: 0 auto;
    justify-content: space-between;
  }
  .van-tabs__wrap:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1px;
    background: #d8d8d8;
    transform: scaleY(0.5);
  }
}
.wrap-library{
  width: 100%;
  position: relative;
  padding-bottom: 120px;
  .recommendPage{
    width: 100%;
    margin-top: 50px;
    text-align: center;
    --swiper-navigation-size:0;
    .lovecontent{

      width: 100%;
      margin: 0 auto;
      //margin-top: 250px;
      ul{
        width: 90%;
        margin: 0 auto;
        //padding-top: 50px;
        li{
          width: 100%;
          display: flex;
          padding-bottom: 40px;
          justify-content: space-between;
          margin: 0 auto;
          .lovecontent-left{
            width: 20%;
            text-align: right;
            span{
              color: #887E89;
            }
          }
          .lovecontent-right{
            width: 100%;
            text-align: center;
            margin: 0 auto;
            span{
              text-align: center;
              font-size: 34px;
              color: #887E89;
            }

          }
        }
        //li:nth-child(-n + 3){
        //  span{
        //    color: #A471AA;
        //  }
        //}

      }

    }
    .recommendPage-title{
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 600;
      font-size: 28px;

      color: #A471AA;
    }
  }
  img{
    display: block;
    width: 100%;
  }
  .iconfont{
    font-size: 26px;
    color:#A471AA;
  }
  .headerimg{
    width: 100%;
    position: relative;
    .realtime{
      position: absolute;
      bottom: 60px;
      right: 45px;

    }
    .relate-black {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 20px;
      background: #FFFFFF;
      border-top-left-radius: 15px;
      border-top-right-radius: 15px;
    }
  }
  .wrap-text-content{
    padding-top: 20px;
    display: flex;
    font-family: row;
    justify-content: space-around;
    align-items: center;
  }
  .left span{
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 34px;
    line-height: 153%;
    /* identical to box height, or 26px */


    color: #000000;
  }
  .right span{
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 28px;
    line-height: 153%;
    /* or 21px */


    color: #898989;
  }
  .right .point{
    padding: 0 10px;
  }
  .pay{
    text-align: center;
    width: 100%;
    height: 100px;
    line-height: 100px;
    background: red;
  }
  .flower{
    /*background: #DF2413;*/
    display: flex;
    vertical-align: center;
    margin: 0 auto;
    position: absolute;
    bottom: -4px;
    right: 0px;
  }
  .one-to-one {
    width: 680px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
      li{
        width: 330px;
        display: flex;
        flex-direction: column;
        background: #fff;
        border-radius: 10px;
        margin-top: 24px;
        position: relative;
        padding-bottom: 30px;
        border-radius: 10px;
        img{
          width: 330px;
          height: 221px;
        }
      }
      li .flower span{
        font-size: 20px;
        color: #fff;
        letter-spacing: 1px;
        margin-left: 5px;
        color: #DF2413;
      }
      li .flower img{
        display: inline-block;
        width: 90px;
        height: 84px;
      }
  }
  .raise-record{
    width: 100%;
    .raise-record-header{
      text-align: center;
      width:84%;
      margin: 50px  auto 0;
      display: flex;
      justify-content: space-between;
      li{
        .reaise-record-title{
          display: block;
          font-family: 'PingFang SC';
          font-style: normal;
          font-weight: 400;
          font-size: 28px;
          /* Donation H5 Color/灰色2 */
          padding-bottom: 20px;
          color: #887E89;
          text-align: left;
        }
        .reaise-record-num{
          display: inline-block;
          font-family: 'PingFang SC';
          font-style: normal;
          font-weight: 500;
          font-size: 38px;
          /* Donation H5 Color/灰色2 */
          color:#AB74B1;
        }
        .unit{
          display: inline-block;
          font-size: 28px;
          margin-left: 8px;
        }
      }
    }
    .raise-progress{
      width: 84%;
      margin: 30px auto 0;
    }
    .raise-line{
      overflow: hidden;
      width: 84%;
      height: 1px;
      background: #000000;
      opacity: 0.1;
      margin: 40px auto ;

    }
    .raise-record-bottom{
      width: 84%;
      margin: 0 auto;

      .raise-record-bottom-text{
        color: #BDB4BE;
        font-size: 34px;
      }
      .raise-record-bottom-text span:nth-child(2){
        font-size: 26px;
      }
      .raise-num{
        width: 100%;
        margin: 30px auto 0;
        display: flex;
        flex-wrap: wrap;
        text-align: center;
        justify-content: space-between;
        li{
          font-size: 30px;
          width: 200px;
          height: 80px;
          line-height: 80px;
          background: #F4F2F4;
          border-radius: 62px;
          margin-bottom: 15px;
          font-family: 'PingFang HK';
          color: #312E31;
        }
        .is-active{
          background-color: #c996c9;
          color: #FFFFFF;
        }
      }
      .raise-custom{
        .van-cell{
          padding: 0;
          height: 80px;
          line-height: 80px;
        }
      }
      .raise-confirm{
        padding-top: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .sum-text{
          font-size: 28px;
          color: #BDB4BE;
        }
        .sum-total{
          font-size: 40px;
          color: #312E31;
          font-weight: 500;
        }
        .sum-unit{
          font-size: 28px;
          margin-left: 5px;
        }
        .sum-confrim{
          width: 340px;
          height: 96px;
          line-height: 96px;
          color: #ffffff;
          background: linear-gradient(69.08deg, #AB73A9 24.17%, #C199C6 74.75%);
          border-radius: 33px;
          text-align: center;
        }

      }
    }
  }
  .donation{
    width: 100%;
    height: 500px;
    background-color: #FFFFFF;
    padding: 37.5px  40px;
    box-sizing: border-box;
    .donation-num{
      font-family: 'PingFang HK';
      font-style: normal;
      font-weight: 500;
      font-size: 34px;
      line-height: 153%;
      color: #BDB4BE;

    }
    .donation-contract{
      width: 300px;
      span{
        font-size: 28px;
      }
    }
    ul{
      width: 100%;
      margin: 20px auto;
      display: flex;
      flex-wrap: wrap;
      text-align: center;
      justify-content: space-between;
      li{
        width: 200px;
        height: 90px;
        line-height: 90px;
        background: #F4F2F4;
        border-radius: 62px;
        margin-bottom: 15px;
      }
      li:nth-child(2){
        margin-left: 20px;
      }
      li:nth-child(3){
        margin-left: 20px;
      }
      li:nth-child(5){
        margin-left: 20px;
      }
      .marginleft{
        margin-left: 20px;
      }
    }
    .is-active{
      background-color: #c996c9;
      color: #FFFFFF;
    }
    .submit{
      margin-top: 36px;
      text-align: center;
      width: 100%;
      height: 96px;
      line-height: 96px;
      background-color: #c996c9;
      color: #FFFFFF;
      border-radius: 125px;
      span{
        font-size: 34px;
      }
    }
  }
  .totaldonation{
    width: 100%;
    //height: 400px;
    background-color: #FFFFFF;
    padding-top: 20px;
    box-sizing: border-box;
    padding-bottom: 50px;
    .oneSub{
         width: 84%;
         margin: 0 auto;
        display: flex;
        justify-content: space-between;
        text-align: center;
        margin-top: 35px;
        span{
          display: block;
          width: 280px;
          height: 80px;
          line-height: 80px;
          background: #F3EBF4;
          border-radius: 40px;
          font-style: normal;
          font-weight: 500;
          font-size: 34px;
          /* or 26px */


          /* Donation H5 Color/主色1 */

          color: #A471AA;
        }
        .donationactive{
          background-color: #c996c9;
          color: #FFFFFF;
        }
    }
  }
  .raise{
    margin-top: 40px;
    .raise-list{
      width:84%;
      margin: 0 auto;
      span{
        display: block;
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 400;
        font-size: 28px;
        line-height: 40px;
        display: flex;
        align-items: center;
        color: #887E89;
        padding-bottom: 20px;
      }
      ul{
        padding: 64px 50px 64px 30px;
        background: #F4F2F4;
        border-radius: 10px;
        li{
          display: flex;
          justify-content: space-between;
          line-height: 2;
          height: 70px;
          span{
            display: inline-block;
            width: 33%;
            text-align: center;
          }
        }
      }
    }
  }
}
.header{
  padding-bottom: 40px;
  width: 680px;
  margin: 0 auto;
}
.title{
  margin-top: 60px;
  width:100%;
  box-sizing: border-box;
  padding: 0 56px;
  height: 42px;
  line-height: 42px;
  font-size: 28px;
  color: #BBB0BC;
  font-family: 'PingFang SC'
}
.title-detail{
  width:90%;
  margin:  0 auto;
  box-sizing: border-box;
  padding: 40px 0px 0px;
}

.title-detail h3{
  font-size: 48px;
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 500;
  line-height: 1.5;
}
.title-content{
  width:90%;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 24px 0px 0px;
}
.title-content p{
  //font-family: 'PingFang HK';
  font-style: normal;
  font-weight: 400;
  font-size: 34px;
  line-height: 164.5%;
  color: #887E89;
 text-align: justify;

}
.title-librarycontent{
  width:90%;
  margin: 0 auto;
  box-sizing: border-box;
  //padding: 24px 0px 0px;
}
.title-librarycontent p{
  //font-family: 'PingFang HK';
  font-style: normal;
  font-weight: 300;
  font-size: 34px;
  line-height: 164.5%;
  color: #000000;
  text-align: justify;
}
.title-librarycontent:nth-child(1) p{
padding-bottom: 30px;
}
.title-librarycontent:nth-child(1) p strong{
  font-weight: bold;
 font-size: 40px;
}
.num{
  margin:0 auto;
  height: 340px;
  background: rgba(193, 153, 198, 0.1);
  border: 1px solid #C199C6;
  box-sizing: border-box;
  border-radius: 5px;
  margin-top: 30px;
}
.num p{
  font-style: normal;
  font-weight: 400;
  font-size: 32px;
  line-height: 164.5%;
  padding: 20px 28px 0;
  text-align: justify;
  /* or 28px */

  color: #AB74B1;
}

.wrap-content{
  background: rgb(245,245,245);
  padding-top: 40px;
  padding-bottom: 20px;
}
.wrap-content .student{
  width: 100%;

}
.student span{
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  line-height: 153%;
  display: block;
  margin-left: 40px;
  color: #BBB0BC;
}

.wrap ul li img{
  border-top-right-radius:10px;
  border-top-left-radius:10px;
}

.wrap .li-status{
  width: 83%;
  height: 80px;
  line-height: 80px;
  background: #c996c9;
  text-align:center;
  margin-top: 20px;
  border-radius: 40px;
  margin: 30px auto 0;
}
.wrap .li-status-dashed{
  width: 83%;
  margin: 30px auto 0;

}
.wrap .donated{
  margin-top: 20px;
}
.wrap .li-status-dashed span{
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  font-size: 34px;
  line-height: 153%;
  /* identical to box height, or 26px */
  color: #AB74B1;
}

.dashed{
  border: 2px dashed #DDDDDD;
  position: relative;
}
.wrap .li-status-border{
  width: 83%;
  height: 70px;
  line-height: 70px;
  text-align:center;
  margin-top: 20px;
  border-radius: 10px;
  margin: 30px auto 0;
  border: 0.5px solid #C199C6;
}
.wrap .li-status-border span{
  color: #C199C6;
  font-size: 34px;
}

.wrap .li-status span{
  font-size: 34px;
   color:#fff;
}
</style>
